export default __webpack_public_path__ + "static/plexus-hero-left-f012392f2e0cbfaa779b6f0c201c7152.webp";